import { useState, useRef, useEffect } from 'react';
import { useSearchBox } from 'react-instantsearch';

//* HOC's
import withLanguageContext from 'context/consumerHOC/LanguageConsumer';

//* Components
import { Input } from 'antd';
import Icon from 'components/common/Icon';

//* Custom SVG Icon
import { searchSVG } from './utils';

const SearchBox = ({ translate, initialQuery = '', onClear, ...props }) => {
	const { query, refine } = useSearchBox(props);

	//! States
	const [inputValue, setInputValue] = useState(initialQuery);
	const [isChanged, setIsChanged] = useState(false);

	//! Ref
	const inputRef = useRef(null);

	useEffect(() => {
		if (initialQuery !== query) {
			setInputValue(initialQuery);
			refine(initialQuery);
		}
	}, [initialQuery]);

	useEffect(() => {
		setInputValue(query);
	}, [query]);

	const handleSearch = (value) => {
		refine(value);
		setIsChanged(false);
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			handleSearch(inputValue);
		}
	};

	const handleClear = () => {
		refine('');
		setInputValue('');
		onClear?.();
		if (inputRef.current) {
			inputRef.current.focus();
		}
	};

	return (
		<div className={`search-field-container new-version ${inputValue && !isChanged ? 'disable-search-button' : ''}`}>
			<Input.Search
				ref={inputRef}
				size='large'
				maxLength={512}
				autoCorrect='off'
				autoComplete='off'
				autoCapitalize='off'
				className='search-field'
				placeholder={translate('typeToSearch')}
				value={inputValue}
				onSearch={handleSearch}
				onKeyDown={handleKeyDown}
				enterButton={searchSVG}
				onChange={(e) => {
					setInputValue(e.currentTarget.value);
					!isChanged && setIsChanged(true);
				}}
			/>

			{inputValue && (
				<Icon
					name='cancel'
					className='search-clear secondaryColor2 p pS'
					onClick={handleClear}
				/>
			)}
		</div>
	);
};

export default withLanguageContext(SearchBox, ['translate']);
